import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import Translate from 'translate';

import AuthService from 'services/AuthService';
import UserService from 'services/UserService';
import ConfigurationService from "services/ConfigurationService";
import { FormGroup, Text } from 'components/FormElements/';
import { required, equalTo } from 'constants/InputErrors';
import { toggleAlertError, toggleLoading } from 'stores/actions/';

class ChangePassword extends React.Component {

  submitForm = ( data ) => {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    UserService.updateUserPassword( data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      toggleAlertError( <Translate id="dataSaved"/> );
      this.props.history.push( '/' )
    } )
  };

  render() {
    return (
      <div className="page-login">
        <div className="main-body pt-5">
          <div className="body-inner">
            <div className="card bg-white">
              <div className="card-content">
                <section className="text-center">
                  <img src="assets/images/logo_smm_minsait.png" width={200} className="mb-3"/>
                </section>

                <Form
                  onSubmit={this.submitForm}
                  validate={values => {
                    return {
                      currentPassword: required( values.currentPassword ),
                      newPassword: required( values.newPassword ),
                      passwordConfirmation: this.entityId ? null
                        : required( values.passwordConfirmation ) ? required( values.passwordConfirmation )
                          : equalTo( values.passwordConfirmation, values.newPassword, 'Password' )
                    }
                  }}
                >
                  {( { submitForm } ) =>
                    <form onSubmit={submitForm}>
                      <div className="form-group mt-3">
                        <Text field="currentPassword" className="form-control" placeholder="currentPassword"
                              type="password"/>
                      </div>

                      <div className="form-group mt-3">
                        <Text field="newPassword" className="form-control" placeholder="password" type="password"/>
                      </div>

                      <div className="form-group mt-3">
                        <Text field="passwordConfirmation" className="form-control" placeholder="passwordConfirmation"
                              type="password"/>
                      </div>

                      <div className="text-right mt-3">
                        <button type="submit" className="btn btn-info text-uppercase">
                          <Translate id="changePassword"/>
                        </button>
                      </div>
                    </form>
                  }
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ( state ) => ( {
  userId: state.user.id,
} );

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( ChangePassword );



// WEBPACK FOOTER //
// ./routes/app/routes/change-password/index.js